import { AuthGuardService } from './services/auth-guard.service';
import { AdminComponent } from './admin/admin.component';
import { LoginComponent } from './login/login.component';
import { ContactComponent } from './contact/contact.component';
import { AboutComponent } from './about/about.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminUsersComponent } from './admin/admin-users/admin-users.component';
import { PrivateSectorComponent } from './admin/private-sector/private-sector.component';
import { PrivateSectorScContentComponent } from './admin/private-sector/private-sector-sc-content/private-sector-sc-content.component';
import { PrivateSectorEditComponent } from './admin/private-sector/private-sector-edit/private-sector-edit.component';


const routes: Routes = [
  { path: 'privacy', component: PrivacyComponent },

  { path: 'about', component: AboutComponent },

  { path: 'contact', component: ContactComponent },

  { path: 'login', component: LoginComponent },

  { path: 'admin', component: AdminComponent, canActivate: [AuthGuardService] },

  { path: 'admin/users', component: AdminUsersComponent, canActivate: [AuthGuardService] },

  { path: 'admin/privatesector', component: PrivateSectorComponent, canActivate: [AuthGuardService] },

  { path: 'admin/privatesector/sc/:id', component: PrivateSectorScContentComponent, canActivate: [AuthGuardService] },

  { path: 'admin/privatesector/edit/:sc/:id', component: PrivateSectorEditComponent, canActivate: [AuthGuardService] },

  { path: '', redirectTo: '/about', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
